import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ce000a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "range-slider" }
const _hoisted_2 = ["min", "max", "step", "value", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "range",
      min: _ctx.min,
      max: _ctx.max,
      step: _ctx.step,
      value: _ctx.modelValue,
      disabled: _ctx.disabled,
      class: "slider",
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args)))
    }, null, 40, _hoisted_2)
  ]))
}